import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getQueryPropertyTypes } from 'store/router/routerSelectors';
import { updateQuery as updateQueryAction } from 'store/search/searchActions';
import PropertyTypeFilter from 'components/Filters/Search/PropertyTypeFilter';

import FilterItem from './FilterItem';

const PropertyTypeFilterItem = () => {
  const dispatch = useDispatch();
  const selectedPropertyTypes = useSelector(getQueryPropertyTypes);

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  const clearFilters = useCallback(() => {
    updateQuery({ propertyTypes: undefined });
  }, [updateQuery]);

  return (
    <FilterItem buttonText="Property Types" isHighlighted={(selectedPropertyTypes || []).length > 0} clearFilters={clearFilters}>
      <PropertyTypeFilter onChange={updateQuery} />
    </FilterItem>
  );
};

export default PropertyTypeFilterItem;
